import EditIcon from "@mui/icons-material/Edit";
import { Box, Chip,Tooltip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro-6";
import React from "react";

import useGatAdminConfigData from "../../../controllers/use-gat-admin-config-data";


interface UseWorkCenterColumnsProps {
    openDialog: () => void;
    setWorkCenterData: React.Dispatch<React.SetStateAction<any>>;
}

const useWorkCenterColumns = ({openDialog, setWorkCenterData}: UseWorkCenterColumnsProps) => {
    const {shiftPatterns} = useGatAdminConfigData()
    const columns: GridColDef[] = [
        {
            field: "name",
            headerName: "Workcenter Name",
            flex: 1,
            minWidth: 130,
            valueGetter: (params) => {
                return params?.row?.name;
            },
            renderHeader: () => (
                <span style={{ fontWeight: "bold" }}>
                    {"Workcenter Name"}
                </span>
            ),
            renderCell: (params) => {
                const workcenterName = params?.row?.name;
                return <Tooltip title={workcenterName}>
                    <span
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                        }}
                    >
                        {workcenterName ? workcenterName : "-"}
                    </span>
                </Tooltip>
            }
        },
        // shift pattern count
        {
            field: "shiftPatternCount",
            headerName: "Shift Pattern Count",
            flex: 1,
            minWidth: 130,
            valueGetter: (params) => {
                return params?.row?.shiftPatternIds.length || 0;
            },
            renderHeader: () => (
                <span style={{ fontWeight: "bold" }}>
                    {"Shift Pattern Count"}
                </span>
            ),
            renderCell: (params) => {
                const shiftPatternCount = params?.row?.shiftPatternIds.length || 0;
                return <span
                    style={{
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        paddingLeft: "8px",
                    }}
                >
                    {shiftPatternCount !== undefined ? shiftPatternCount : "-"}
                </span>
            }
        },
        // Shift Patterns
        {
            field: "shiftPatterns",
            headerName: "Shift Patterns",
            flex: 2,
            minWidth: 200,
            renderHeader: () => (
                <span style={{ fontWeight: "bold" }}>
                    {"Shift Patterns"}
                </span>
            ),
            valueGetter: (params) => {
                return params?.row?.shiftPatternIds || [];
            },
            sortable: false,
            renderCell: (params) => {
                const shiftPatternIds = params?.row?.shiftPatternIds || [];
                const shiftPatternNames = shiftPatterns
                    .filter((sp) => shiftPatternIds.includes(sp.id))
                    .map((sp) => sp.name);
                return (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, py: 1.5 }}>
                        {
                            shiftPatternNames.length > 0 ? shiftPatternNames.map((name, index) => (
                                <Chip key={index} label={name} size="medium" />
                            )) : <span style={{ color: "rgba(0, 0, 0, 0.6)" }}>-</span>
                        }
                    </Box>
                );
            }
        },
        // Action to edit workcenter
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            minWidth: 100,
            sortable: false,
            renderHeader: () => (
                <span style={{ fontWeight: "bold" }}>
                    {"Actions"}
                </span>
            ),
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            gap: 1,
                        }}
                    >
                        <EditIcon
                            sx={{ cursor: "pointer",
                                color: "rgba(0, 0, 0, 0.87)",
                                fontSize: 24
                             }}
                            onClick={() => {
                                setWorkCenterData(params?.row);
                                openDialog();
                            }}
                        />
                    </Box>
                );
            },
        },
    ]

    return columns;
};

export default useWorkCenterColumns;
